export default __webpack_public_path__ + "static/media/5.db606c9a.webp";